/**
 * @generated SignedSource<<53f353439291d52f8c8155a498d0f5e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EventTimetableEditPageQuery$variables = {
  slug: string;
};
export type EventTimetableEditPageQuery$data = {
  readonly eventBySlug: {
    readonly agenda: any | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type EventTimetableEditPageQuery = {
  response: EventTimetableEditPageQuery$data;
  variables: EventTimetableEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "Event",
    "kind": "LinkedField",
    "name": "eventBySlug",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "agenda",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventTimetableEditPageQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EventTimetableEditPageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aa481a1b02c670cce9ef4539cd1f0e86",
    "id": null,
    "metadata": {},
    "name": "EventTimetableEditPageQuery",
    "operationKind": "query",
    "text": "query EventTimetableEditPageQuery(\n  $slug: String!\n) {\n  eventBySlug(slug: $slug) {\n    id\n    agenda\n  }\n}\n"
  }
};
})();

(node as any).hash = "92b6e09b12c56aff3e90fc365c045e5b";

export default node;
